import { GroupSearchResult } from 'graphql/types';

export const mapToUiAccessSope = (
  groups: {
    id: string;
    displayText: string;
  }[]
): {
  id: string;
  displayText: string;
}[] => {
  return groups
    ? groups.map(({ id, displayText }) => ({
        id: id!,
        displayText: displayText!
      }))
    : [];
};
export const mapToAccessSope = (
  key: string,
  groups: GroupSearchResult[]
):
  | {
      [x: string]: {
        id: string;
        displayText: string;
      }[];
    }
  | undefined => {
  return groups
    ? {
        [key]: groups.map(({ id, displayText }) => ({
          id: id!,
          displayText: displayText!
        }))
      }
    : undefined;
};
